import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  ColumnLayout,
  Box,
  ExpandableSection,
  StatusIndicator
} from '@cloudscape-design/components';

const ImplementationRoadmap = ({ roadmap }) => {
  return (
    <SpaceBetween size="l">
      <Container
        header={
          <Header
            variant="h2"
            description="Phased implementation plan for the domain architecture"
          >
            Implementation Roadmap
          </Header>
        }
      >
        {roadmap.phases.map((phase, index) => (
          <ExpandableSection
            key={index}
            header={
              <Header variant="h3">
                {phase.phase}
              </Header>
            }
          >
            <SpaceBetween size="m">
              <ColumnLayout columns={2}>
                <Box>
                  <Box variant="awsui-key-label">Domains</Box>
                  <ul>
                    {phase.domains.map((domain, i) => (
                      <li key={i}>{domain}</li>
                    ))}
                  </ul>
                </Box>
                <Box>
                  <Box variant="awsui-key-label">Dependencies</Box>
                  <ul>
                    {phase.dependencies.map((dep, i) => (
                      <li key={i}>{dep}</li>
                    ))}
                  </ul>
                </Box>
              </ColumnLayout>
              <ExpandableSection header="Technical Considerations">
                <ul>
                  {phase.technical_considerations.map((consideration, i) => (
                    <li key={i}>{consideration}</li>
                  ))}
                </ul>
              </ExpandableSection>
              <ExpandableSection header="Risk Factors">
                <ul>
                  {phase.risk_factors.map((risk, i) => (
                    <li key={i}>{risk}</li>
                  ))}
                </ul>
              </ExpandableSection>
            </SpaceBetween>
          </ExpandableSection>
        ))}
      </Container>

      <Container
        header={
          <Header variant="h3">Critical Path</Header>
        }
      >
        <ol>
          {roadmap.critical_path.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ol>
      </Container>

      <Container
        header={
          <Header variant="h3">Risk Mitigation Strategies</Header>
        }
      >
        {Object.entries(roadmap.risk_mitigation).map(([risk, strategy], index) => (
          <SpaceBetween size="xs" key={index}>
            <Box variant="strong">{risk}</Box>
            <Box>{strategy}</Box>
          </SpaceBetween>
        ))}
      </Container>
    </SpaceBetween>
  );
};

export default ImplementationRoadmap;
